<div class="panel">

  <!-- ── Head ──────────────────────────────────────────────────────────────── -->
  <header class="panel__head">
    <ng-content select="[panel-head]">
      <!-- fallback : titre simple via @Input -->
      <span class="panel__title">{{ title }}</span>
    </ng-content>
  </header>

  <!-- ── Body ──────────────────────────────────────────────────────────────── -->
  <div class="panel__body">
    <ng-content></ng-content>
  </div>

  <!-- ── Foot (optionnel) ───────────────────────────────────────────────────── -->
  @if (hasFooter) {
    <footer class="panel__foot">
      <ng-content select="[panel-foot]"></ng-content>
    </footer>
  }

</div>
